import React, { createContext, useContext, useState, useEffect } from 'react';

const SettingsContext = createContext();

export const useSettings = () => {
  const context = useContext(SettingsContext);
  if (!context) {
    throw new Error('useSettings must be used within a SettingsProvider');
  }
  return context;
};

export const SettingsProvider = ({ children }) => {
  const [settings, setSettings] = useState({
    system: {
      chatSystemEnabled: false, // Chat system disabled by default
      maintenanceMode: false,
      debugMode: false
    }
  });

  // Load settings from localStorage on mount
  useEffect(() => {
    const savedSettings = localStorage.getItem('sunx_admin_settings');
    if (savedSettings) {
      try {
        const parsed = JSON.parse(savedSettings);
        setSettings(prev => ({
          ...prev,
          ...parsed
        }));
      } catch (error) {
        console.error('Error loading settings:', error);
      }
    }
  }, []);

  // Save settings to localStorage whenever they change
  const updateSettings = (newSettings) => {
    setSettings(newSettings);
    localStorage.setItem('sunx_admin_settings', JSON.stringify(newSettings));
  };

  const updateSystemSetting = (key, value) => {
    const newSettings = {
      ...settings,
      system: {
        ...settings.system,
        [key]: value
      }
    };
    updateSettings(newSettings);
  };

  const value = {
    settings,
    updateSettings,
    updateSystemSetting,
    isChatEnabled: settings.system.chatSystemEnabled
  };

  return (
    <SettingsContext.Provider value={value}>
      {children}
    </SettingsContext.Provider>
  );
};
